export const US_NOTICE_COOKIE = "ouster-us-notice";
export const US_NOTICE_PENDING_KEY = "ouster-us-preferences-pending";
const YEAR_MS = 365 * 24 * 60 * 60 * 1000;
export function hasNoticeAcknowledgment(cookie: string, now = Date.now()) {
  const value = cookie.split(";").map(part => part.trim()).find(part => part.startsWith(`${US_NOTICE_COOKIE}=`));
  const match = value?.match(/^ouster-us-notice=v1\.(\d+)$/);
  const timestamp = Number(match?.[1]);
  return Boolean(match && timestamp > 0 && timestamp <= now && now - timestamp < YEAR_MS);
}
export function noticeAcknowledgmentCookie(secure: boolean, now = Date.now()) {
  return `${US_NOTICE_COOKIE}=v1.${now}; Path=/; Max-Age=${YEAR_MS / 1000}; SameSite=Lax${secure ? "; Secure" : ""}`;
}